import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdresseEntite } from '../entites/adresse';
import { ReponseBase } from './reponse-base';

/**
 * Service for address localisation and geocoding operations.
 * Uses redundant API providers (Google Places, GeoEGL) with automatic failover.
 */
@Injectable({ providedIn: 'root' })
export class LocalisationService {

    private rechercherAdresseUrl = environment.apiBaseUrl + 'localisation/recherche';
    private obtenirProvidersUrl = environment.apiBaseUrl + 'localisation/providers';

    constructor(private http: HttpClient) { }

    /**
     * Searches for addresses matching the given search query.
     * Automatically tries Google Places first, then falls back to GeoEGL if needed.
     * @param searchQuery The address search query (e.g., "123 Main St, Quebec, G1A 1A1" or "123 G1A1A1")
     * @returns Observable of response containing list of matching addresses
     */
    public rechercherAdresse(searchQuery: string): Observable<ReponseBase<AdresseEntite[]>> {
        return this.http.get<ReponseBase<AdresseEntite[]>>(this.rechercherAdresseUrl, {
            params: { searchQuery }
        });
    }

    /**
     * Searches for an address using numero (street number) and code postal (postal code).
     * This is a convenience method that builds the search query from separate parameters.
     * @param numero The street number (e.g., "123")
     * @param codePostal The postal code (e.g., "G1A 1A1" or "G1A1A1")
     * @returns Observable of response containing list of matching addresses
     */
    public rechercherAdresseParNumeroEtCodePostal(numero: string, codePostal: string): Observable<ReponseBase<AdresseEntite[]>> {
        const searchQuery = `${numero} ${codePostal}`;
        return this.rechercherAdresse(searchQuery);
    }

    /**
     * Gets the list of available localisation providers in priority order.
     * Useful for monitoring and debugging which providers are configured.
     * @returns Observable of response containing list of provider names
     */
    public obtenirProviders(): Observable<ReponseBase<string[]>> {
        return this.http.get<ReponseBase<string[]>>(this.obtenirProvidersUrl);
    }
}

